import { z } from "zod";
import { EtlErroredSchema } from "./etlErrored.trait";
import { EtlIgnoredSchema } from "./etlIgnored.trait";
import { EtlMessageSchema } from "./etlMessage.trait";

export const AllEtlTraitsSchema = EtlErroredSchema
	.merge(EtlIgnoredSchema)
	.merge(EtlMessageSchema)
	.merge(z.object({}));

export type AllEtlTraits = z.infer<typeof AllEtlTraitsSchema>;
